<template>
  <div>
    <em>{{ $t('form.working_hours.option_a.help') }}</em>
    <div>
      <label class="mb-0">
        <em>{{ $t('form.working_hours.days.monday') }}</em>
      </label>

      <div class="inline">
        <div>
          <label class="mt-0" for="option_a_monday_start">{{ $t('form.working_hours.option_a.day.start.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_monday_start" :placeholder="$t('form.working_hours.option_a.day.start.placeholder')"
              v-model="days.monday.start" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>

        <div class="ml-3">
          <label class="mt-0" for="option_a_monday_end">{{ $t('form.working_hours.option_a.day.end.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_monday_end" :placeholder="$t('form.working_hours.option_a.day.end.placeholder')"
              v-model="days.monday.end" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>


    <div>
      <label class="mb-0">
        <em>{{ $t('form.working_hours.days.tuesday') }}</em>
      </label>

      <div class="inline">
        <div>
          <label class="mt-0" for="option_a_tuesday_start">{{ $t('form.working_hours.option_a.day.start.label')
            }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_tuesday_start" :placeholder="$t('form.working_hours.option_a.day.start.placeholder')"
              v-model="days.tuesday.start" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>

        <div class="ml-3">
          <label class="mt-0" for="option_a_tuesday_end">{{ $t('form.working_hours.option_a.day.end.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_tuesday_end" :placeholder="$t('form.working_hours.option_a.day.end.placeholder')"
              v-model="days.tuesday.end" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>


    <div>
      <label class="mb-0">
        <em>{{ $t('form.working_hours.days.wednesday') }}</em>
      </label>

      <div class="inline">
        <div>
          <label class="mt-0" for="option_a_wednesday_start">{{ $t('form.working_hours.option_a.day.start.label')
            }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_wednesday_start" :placeholder="$t('form.working_hours.option_a.day.start.placeholder')"
              v-model="days.wednesday.start" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
              required autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>

        <div class="ml-3">
          <label class="mt-0" for="option_a_wednesday_end">{{ $t('form.working_hours.option_a.day.end.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_wednesday_end" :placeholder="$t('form.working_hours.option_a.day.end.placeholder')"
              v-model="days.wednesday.end" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>


    <div>
      <label class="mb-0">
        <em>{{ $t('form.working_hours.days.thursday') }}</em>
      </label>

      <div class="inline">
        <div>
          <label class="mt-0" for="option_a_thursday_start">{{ $t('form.working_hours.option_a.day.start.label')
            }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_thursday_start" :placeholder="$t('form.working_hours.option_a.day.start.placeholder')"
              v-model="days.thursday.start" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
              required autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>

        <div class="ml-3">
          <label class="mt-0" for="option_a_thursday_end">{{ $t('form.working_hours.option_a.day.end.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_thursday_end" :placeholder="$t('form.working_hours.option_a.day.end.placeholder')"
              v-model="days.thursday.end" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>


    <div>
      <label class="mb-0">
        <em>{{ $t('form.working_hours.days.friday') }}</em>
      </label>

      <div class="inline">
        <div>
          <label class="mt-0" for="option_a_friday_start">{{ $t('form.working_hours.option_a.day.start.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_friday_start" :placeholder="$t('form.working_hours.option_a.day.start.placeholder')"
              v-model="days.friday.start" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>

        <div class="ml-3">
          <label class="mt-0" for="option_a_friday_end">{{ $t('form.working_hours.option_a.day.end.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_friday_end" :placeholder="$t('form.working_hours.option_a.day.end.placeholder')"
              v-model="days.friday.end" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>


    <div>
      <label class="mb-0">
        <em>{{ $t('form.working_hours.days.saturday') }}</em>
      </label>

      <div class="inline">
        <div>
          <label class="mt-0" for="option_a_saturday_start">{{ $t('form.working_hours.option_a.day.start.label')
            }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_saturday_start" :placeholder="$t('form.working_hours.option_a.day.start.placeholder')"
              v-model="days.saturday.start" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
              required autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>

        <div class="ml-3">
          <label class="mt-0" for="option_a_saturday_end">{{ $t('form.working_hours.option_a.day.end.label') }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="option_a_saturday_end" :placeholder="$t('form.working_hours.option_a.day.end.placeholder')"
              v-model="days.saturday.end" @invalid="expandContent($refs.collapseLink, $refs.collapseElement)" required
              autocomplete="off">
            <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      days: {
        monday: {
          start: '',
          end: '',
        },
        tuesday: {
          start: '',
          end: '',
        },
        wednesday: {
          start: '',
          end: '',
        },
        thursday: {
          start: '',
          end: '',
        },
        friday: {
          start: '',
          end: '',
        },
        saturday: {
          start: '',
          end: '',
        },
      },
    };
  },
  watch: {
    days: {
      handler() {
        this.$store.commit('updateWorkingHoursInputA', this.days);
      },
      deep: true,
    },
  },
};
</script>
